import './Badge.scss';

import PropTypes from 'prop-types';
import React from 'react';
import Constants from 'Shared/constants';

const Badge = ({ label, type, size, className, style, inline }) => {
	return (
		<div className={`react__badge ${type} ${size} ${className} ${inline ? 'inline' : ''}`} style={style}>
			{label}
		</div>
	);
};

Badge.propTypes = {
	label: PropTypes.string.isRequired,
	type: PropTypes.oneOf(Constants.TYPES),
	size: PropTypes.oneOf(Constants.SIZES),
	className: PropTypes.string,
	style: PropTypes.object,
	inline: PropTypes.bool
};

Badge.defaultProps = {
	type: 'bright',
	size: 's',
	className: '',
	style: {},
	inline: false
};

export default Badge;
